import { ReactNode } from 'react'

import { cn } from '@/shared/lib'

type CommonProps = {
  className?: string
  children?: ReactNode
}

export const List = ({ children, className }: CommonProps) => {
  return <dl className={cn('space-y-2', className)}>{children}</dl>
}

type ItemProps = CommonProps & {
  label?: ReactNode
  value?: ReactNode
  lineThrough?: boolean
}

export const Item = ({
  children,
  className,
  label,
  value,
  lineThrough,
}: ItemProps) => {
  return (
    <div className={cn('typo-label1 flex items-center gap-6', className)}>
      {(() => {
        if (children) {
          return children
        }

        return (
          <>
            <ItemLabel>{label}</ItemLabel>
            <ItemValue lineThrough={lineThrough}>{value}</ItemValue>
          </>
        )
      })()}
    </div>
  )
}

type ItemChildrenProps = CommonProps & {
  bold?: boolean
  semiBold?: boolean
  normal?: boolean
  light?: boolean
  highlight?: boolean
}

export const ItemLabel = ({
  bold,
  semiBold,
  normal,
  light,
  highlight,
  className,
  children,
}: ItemChildrenProps) => {
  return (
    <dt
      className={cn(
        'h-fit min-w-[49px] font-medium text-gray-500',
        bold && 'font-bold',
        semiBold && 'font-semibold',
        normal && 'font-normal',
        light && 'font-light',
        highlight && 'text-purple-500',
        className,
      )}
    >
      {children}
    </dt>
  )
}

type ItemValueProps = ItemChildrenProps & {
  lineThrough?: boolean
}

export const ItemValue = ({
  bold,
  semiBold,
  normal,
  light,
  highlight,
  lineThrough,
  className,
  children,
}: ItemValueProps) => {
  return (
    <dd
      className={cn(
        'font-medium text-gray-900',
        bold && 'font-bold',
        semiBold && 'font-semibold',
        normal && 'font-normal',
        light && 'font-light',
        highlight && 'text-purple-500',
        lineThrough && 'line-through',
        className,
      )}
    >
      {children}
    </dd>
  )
}
